import { createContext } from 'react';

const PricesContext = createContext({});

export default PricesContext;
